/**
 * @generated SignedSource<<0187b49d7b27e9b8ff3f5b0e0a3acd01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type FollowUserInput = {
  userId: string;
};
export type UserFollowButtonFollowMutation$variables = {
  input: FollowUserInput;
};
export type UserFollowButtonFollowMutation$data = {
  readonly followUser: {
    readonly user: {
      readonly id: string;
      readonly viewerIsFollowing: boolean;
      readonly followers: {
        readonly pageInfo: {
          readonly total: number;
        };
      };
    } | null;
  } | null;
};
export type UserFollowButtonFollowMutation = {
  variables: UserFollowButtonFollowMutation$variables;
  response: UserFollowButtonFollowMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FollowUserPayload",
    "kind": "LinkedField",
    "name": "followUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerIsFollowing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              }
            ],
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "followers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "followers(first:1)"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserFollowButtonFollowMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserFollowButtonFollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "63e4890ae40d41b81204a32d6399ed53",
    "id": null,
    "metadata": {},
    "name": "UserFollowButtonFollowMutation",
    "operationKind": "mutation",
    "text": "mutation UserFollowButtonFollowMutation(\n  $input: FollowUserInput!\n) {\n  followUser(input: $input) {\n    user {\n      id\n      viewerIsFollowing\n      followers(first: 1) {\n        pageInfo {\n          total\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b1fafb983821baa1b57be538e72ebc9c";

export default node;
